import React, { Component } from 'react';
// @ts-ignore react-google-recaptcha ships no type declarations
import ReCAPTCHA from 'react-google-recaptcha';
import cn from 'classnames';
import recaptchaConfig from '@framework/config/recaptcha';
import FormError from '@dealroadshow/uikit-form/FormError';
import FormField from '@dealroadshow/uikit-form/FormField';
import styles from './recaptcha.module.scss';

interface IProps {
  meta: any,
  input: any,
  onChange?: (hash: any) => void,
  className: string,
  visible?: boolean,
  dataTest: string,
  formFieldClassName: string,
}

const defaultProps: Partial<IProps> = {
  onChange: () => {},
  visible: true,
};

class ReCaptcha extends Component<IProps, any> {
  static defaultProps: Partial<IProps> = defaultProps;

  constructor(props: IProps) {
    super(props);

    this.state = {
      expired: false,
    };

    this.recaptchaRef = React.createRef();
  }

  componentDidUpdate(prevProps: IProps) {
    if (!!prevProps.input.value && !this.props.input.value && !this.state.expired) {
      // should be fixed in updates of plugin
      this.recaptchaRef.current?.reset();
    }
  }

  public recaptchaRef: any;

  onVerified = (hash: string | null) => {
    this.setState({
      expired: !hash,
    });

    this.onChanged(hash);
  };

  onExpired = () => {
    this.setState({
      expired: true,
    });

    this.onChanged(null);
  };

  onChanged = (hash: string | null) => {
    if (this.props.input && ('onChange' in this.props.input)) {
      this.props.input.onChange(hash);
      return;
    }

    // @ts-ignore
    this.props.onChange(hash);
  };

  render() {
    const { meta, visible, className, dataTest, formFieldClassName } = this.props;
    const size = visible ? 'normal' : 'invisible';
    const siteKey = visible
      ? recaptchaConfig.visible.siteKey
      : recaptchaConfig.invisible.siteKey;
    return (
      <FormField
        isValidationFeedback={ !!(meta && meta.touched && meta.error) }
        dataTest={ dataTest }
        className={ formFieldClassName }
      >
        <div className={ cn(styles.recaptchaWrp, className) }>
          <ReCAPTCHA
            ref={ this.recaptchaRef }
            size={ size }
            sitekey={ siteKey }
            onChange={ this.onVerified }
            onExpired={ this.onExpired }
            onErrored={ () => this.onVerified(null) }
          />
          <FormError
            { ...meta }
            touched={ meta.touched && !this.state.expired }
          />
        </div>
      </FormField>
    );
  }
}

export default ReCaptcha;
